/**
 * Client-safe locale constants. Kept in a separate module so the client
 * `LocaleProvider` can import them without dragging in `next/headers`
 * (which is server-only).
 */
export const LOCALE_COOKIE = "bwit_locale";
/** 1 year — locale is a long-lived preference. */
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
